(() => {
  const initNewsletterForm = (section) => {
    if (!section || section.dataset.newsletterInitialized === 'true') return;

    const form = section.querySelector('[data-newsletter-form]');
    const message = section.querySelector('[data-newsletter-message]');
    const button = form?.querySelector('button[type="submit"]');

    if (!form) return;

    section.dataset.newsletterInitialized = 'true';

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const endpoint = form.getAttribute('action');

      if (!endpoint) return;

      const emailInput = form.querySelector('input[name="email"]');
      const privacyInput = form.querySelector('input[name="privacyPolicy"]');

      const email = emailInput?.value?.trim();
      const privacyPolicy = privacyInput ? privacyInput.checked : true;
      const lang = section.dataset.locale || 'ES';

      if (!email) return;

      if (privacyInput && !privacyPolicy) {
        if (message) {
          message.textContent = section.dataset.errorMessage || 'Something went wrong. Please try again.';
        }

        return;
      }

      const payload = {
        email,
        privacyPolicy,
        lang
      };

      if (message) {
        message.textContent = '';
      }

      button?.classList.add('is-loading');
      button?.setAttribute('disabled', 'disabled');

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Form submission failed');
        }

        form.reset();

        if (message) {
          message.textContent =
            section.dataset.successMessage || 'Thank you for signing up.';
        }
      } catch (error) {
        if (message) {
          message.textContent =
            section.dataset.errorMessage || 'Something went wrong. Please try again.';
        }
      } finally {
        button?.classList.remove('is-loading');
        button?.removeAttribute('disabled');
      }
    });
  };

  const initAllNewsletterForms = () => {
    document
      .querySelectorAll('[data-custom-newsletter-form]')
      .forEach(initNewsletterForm);
  };

  document.addEventListener('DOMContentLoaded', initAllNewsletterForms);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-custom-newsletter-form]');

    if (section) {
      initNewsletterForm(section);
    }
  });
})();